import { render, staticRenderFns } from "./MetadataField.vue?vue&type=template&id=464fc90c&scoped=true&"
import script from "./MetadataField.vue?vue&type=script&lang=js&"
export * from "./MetadataField.vue?vue&type=script&lang=js&"
import style0 from "./MetadataField.vue?vue&type=style&index=0&id=464fc90c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464fc90c",
  null
  
)

export default component.exports